/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Notes_CtaInputs */

const en_fc_dl_notes_cta = /** @type {(inputs: Fc_Dl_Notes_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read release notes`)
};

/**
* | output |
* | --- |
* | "Read release notes" |
*
* @param {Fc_Dl_Notes_CtaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_notes_cta = /** @type {((inputs?: Fc_Dl_Notes_CtaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Notes_CtaInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_notes_cta(inputs)
});
export { fc_dl_notes_cta as "fc.dl.notes.cta" }